import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ICase } from '../../cases/interfaces/case.interface';
import { CaseInfo } from '../../cases/interfaces/cases-data.interface';
import { EnvService } from 'src/app/services/env.service';

@Injectable({
  providedIn: 'root',
})
export class CaseService {
  readonly baseUrl = `${this.env.URL_API_V1}/case`;

  constructor(private readonly http: HttpClient, private env: EnvService) {}

  filterData = new Subject();
  updateCaseTaskRAs = new Subject();
  updateCaseStatusFRD = new Subject();
  getCaseInformation(id) {
    return this.http.get<CaseInfo[]>(`${this.baseUrl}/information/${id}`);
  }

  /** Filtro del Timeline compartido por todos los que abren el caso (SCG-369). */
  saveTimelineState(id: string, timelineState: any) {
    return this.http.put(`${this.baseUrl}/timeline-state/${id}`, {
      timelineState,
    });
  }

  getCase(id) {
    return this.http.get<ICase>(`${this.baseUrl}/get/${id}`);
  }
  getCasesResume() {
    return this.http.get<ICase>(`${this.baseUrl}/resumeGetAll`);
  }

  updateStatusAndOrder(cases: ICase[]) {
    this.http
      .put(`${this.baseUrl}/statusAndOrder`, { cases })
      .pipe(take(1))
      .subscribe();
  }

  create(data) {
    return this.http.post<ICase>(`${this.baseUrl}/create`, data);
  }

  caseCreated = new Subject<ICase>();

  delete(id, user) {
    return this.http.post(`${this.baseUrl}/delete/${id}`, user);
  }

  caseDeleted = new Subject<ICase>();

  update(id, data) {
    return this.http.put<ICase>(`${this.baseUrl}/update/${id}`, data);
  }

  requestApproval(id, data) {
    return this.http.post(`${this.baseUrl}/requestApproval/${id}`, data);
  }
  rejectApproval(id, data) {
    return this.http.post(`${this.baseUrl}/rejectApproval/${id}`, data);
  }
  acceptApproval(id) {
    return this.http.post(`${this.baseUrl}/acceptApproval/${id}`, null);
  }
  requestApprovalUserApproval(id, data) {
    return this.http.post(
      `${this.baseUrl}/requestApprovalUserApproval/${id}`,
      data
    );
  }
  remitToCasosSinAsignar(id: string, userId: string): Observable<ICase> {
    return this.http.post<ICase>(
      `${this.baseUrl}/remitToCasosSinAsignar/${id}`,
      { id: userId }
    );
  }

  exportLdcExcel(case_id: string) {
    return this.http.get(`${this.baseUrl}/exportLdc/${case_id}`);
  }
  rejectCaseAssignament(id, data) {
    return this.http.post(`${this.baseUrl}/caseAssignamentReject/${id}`, data);
  }

  caseRefusedByFalseCase(id) {
    return this.http.put<ICase>(`${this.baseUrl}/caseRefusedByFalseCase`, {
      id,
    });
  }
}
